import RandingStyle19 from "../../randing/RandingStyle19";

function Randing146({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle19
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="3"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/146/1-1.gif`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/146/2-1.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/146/3-1.jpg`}
      numberColor="#201c54"
      qOptionColor="blue"
      qOptionColor2="age"
      qTitleColor="#204cec"
      formFieldColor="white"
      audioOn={true}
      passBTN={`${process.env.REACT_APP_CDN_BASE}/images/146/1-2.png`}
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/146/2-2.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton2.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
      randingNumber="146"
    />
  );
}

export default Randing146;
